import { ReactNode } from 'react';

import { Icon } from './icon';
import { Button } from './shadcn/button';
import { PopoverContent } from './shadcn/popover';

export function FilterPopoverContent({
  children,
  clearAllFilters,
}: {
  children?: ReactNode;
  clearAllFilters: () => void;
}) {
  return (
    <PopoverContent side="left" className="mt-12 min-w-md" sideOffset={8}>
      <div className="-mx-4 -mt-3 rounded-t-md border-b bg-gray-50 p-4 font-medium text-gray-700">Filters</div>

      <div className="mt-4 flex flex-col gap-4">{children}</div>

      <div className="mt-4 flex w-full justify-end">
        <Button onClick={clearAllFilters}>
          <Icon className="lucide--funnel-x" />
          <span>Clear All Filters</span>
        </Button>
      </div>
    </PopoverContent>
  );
}
